<template>
  <div>
    <div class="areas-grid">
      <div v-for="f in filas" :key="f.area" class="area-card">
        <div class="area-head" :style="{ background: softArea(f.area) }">
          <span class="area-dot" :style="{ background: colorArea(f.area) }"></span>
          <span class="area-name" :style="{ color: colorArea(f.area) }">{{ f.area }}</span>
          <span class="area-total" :style="{ color: colorArea(f.area) }">{{ f.total }}</span>
        </div>
        <div class="area-body">
          <button
            class="area-row"
            :class="{ clickable: f.abiertos > 0 }"
            :disabled="f.abiertos === 0"
            @click="abrir(f.area, 'Abiertos', f.abiertosList)"
          >
            <span class="row-label">Abiertos</span>
            <span class="row-val">{{ f.abiertos }}</span>
          </button>
          <button
            class="area-row"
            :class="{ clickable: f.concluidos > 0 }"
            :disabled="f.concluidos === 0"
            @click="abrir(f.area, 'Concluidos', f.concluidosList)"
          >
            <span class="row-label">Concluidos</span>
            <span class="row-val">{{ f.concluidos }}</span>
          </button>
          <button
            class="area-row"
            :class="{ clickable: f.venc > 0 }"
            :disabled="f.venc === 0"
            @click="abrir(f.area, 'Vencidos', f.vencList)"
          >
            <span class="row-label">Vencidos</span>
            <span class="row-val" :style="{ color: f.venc > 0 ? '#dc2626' : 'var(--pt-text)' }">
              {{ f.venc }}
            </span>
          </button>
          <div>
            <div class="avance-head">
              <span class="row-label">Avance promedio</span>
              <span class="avance-pct" :style="{ color: colorArea(f.area) }">
                {{ f.avance }}%
              </span>
            </div>
            <div class="avance-track">
              <div
                class="avance-fill"
                :style="{ width: f.avance + '%', background: colorArea(f.area) }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Detalle de incidencias del bucket seleccionado -->
    <div v-if="detalle" class="det-overlay" @click="detalle = null">
      <div class="det-modal" @click.stop>
        <div class="det-head" :style="{ background: softArea(detalle.area) }">
          <span class="area-dot" :style="{ background: colorArea(detalle.area) }"></span>
          <div class="det-titles">
            <span class="det-area" :style="{ color: colorArea(detalle.area) }">
              {{ detalle.area }}
            </span>
            <span class="det-sub">{{ detalle.bucket }} · {{ detalle.items.length }}</span>
          </div>
          <button class="det-close" @click="detalle = null">
            <PortalIcon name="X" :size="20" />
          </button>
        </div>
        <div class="det-body">
          <div v-for="r in detalle.items" :key="r.id" class="det-item">
            <span class="det-folio">{{ r.folio }}</span>
            <div class="det-main">
              <div class="det-cli">{{ r.cliente }}</div>
              <div class="det-asu">{{ r.asunto }}</div>
              <div class="det-meta">
                <span
                  class="det-estatus"
                  :style="{
                    color: ESTATUS_COLOR[normEstatus(r.estatus)],
                    background: ESTATUS_COLOR[normEstatus(r.estatus)] + '1a',
                  }"
                >{{ normEstatus(r.estatus) }}</span>
                <span class="det-prio" :style="{ color: PRIORIDAD_COLOR[r.prioridad] || 'var(--pt-muted)' }">
                  {{ r.prioridad }}
                </span>
                <span class="det-sla" :style="{ color: SLA_COLOR[r._sla] || 'var(--pt-muted)' }">
                  {{ r._sla }}<template v-if="r.fechaCompromiso"> · {{ fmt(r.fechaCompromiso) }}</template>
                </span>
              </div>
            </div>
            <div class="det-av">{{ r._av }}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PortalIcon from "./PortalIcon.vue";
import { ESTATUS_COLOR, PRIORIDAD_COLOR, SLA_COLOR } from "./portal.constants";
import { normEstatus, avanceDe, colorArea, softArea, fmt } from "./portal.helpers";

export default {
  name: "AreasTab",
  components: { PortalIcon },
  props: {
    reg: { type: Array, default: () => [] },
  },
  data() {
    return {
      ESTATUS_COLOR,
      PRIORIDAD_COLOR,
      SLA_COLOR,
      detalle: null, // { area, bucket, items }
    };
  },
  computed: {
    filas() {
      const map = {};
      this.reg.forEach((r) => {
        (map[r.area] = map[r.area] || []).push(r);
      });
      return Object.entries(map)
        .map(([area, items]) => {
          const abiertosList = items.filter(
            (r) =>
              normEstatus(r.estatus) !== "Concluido" &&
              normEstatus(r.estatus) !== "Declinado"
          );
          const concluidosList = items.filter(
            (r) => normEstatus(r.estatus) === "Concluido"
          );
          const vencList = items.filter((r) => r._sla === "Vencido");
          const avance = Math.round(
            items.reduce((a, r) => a + avanceDe(r), 0) / items.length
          );
          return {
            area,
            total: items.length,
            abiertos: abiertosList.length,
            concluidos: concluidosList.length,
            venc: vencList.length,
            avance,
            abiertosList,
            concluidosList,
            vencList,
          };
        })
        .sort((a, b) => b.total - a.total);
    },
  },
  methods: {
    colorArea,
    softArea,
    normEstatus,
    fmt,
    abrir(area, bucket, items) {
      if (!items || !items.length) return;
      this.detalle = { area, bucket, items };
    },
  },
};
</script>

<style scoped>
.areas-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
.area-card {
  background: var(--pt-card);
  border: 1px solid var(--pt-border);
  border-radius: 16px;
  overflow: hidden;
}
.area-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}
.area-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex-shrink: 0;
}
.area-name {
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.area-total {
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.area-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.area-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  width: 100%;
  background: none;
  border: 0;
  padding: 2px 4px;
  margin: -2px -4px;
  border-radius: 8px;
  font-family: inherit;
  text-align: left;
  color: inherit;
}
.area-row.clickable {
  cursor: pointer;
}
.area-row.clickable:hover {
  background: var(--pt-track);
}
.area-row:disabled {
  cursor: default;
}
.row-label {
  color: var(--pt-dim);
}
.row-val {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--pt-text);
}
.avance-head {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 4px;
}
.avance-pct {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.avance-track {
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--pt-track);
}
.avance-fill {
  height: 100%;
  border-radius: 999px;
}

/* Modal de detalle */
.det-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.45);
}
.det-modal {
  width: 100%;
  max-width: 640px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--pt-card);
  border-radius: 16px;
  overflow: hidden;
}
.det-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
}
.det-titles {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.det-area {
  font-weight: 700;
}
.det-sub {
  font-size: 12px;
  color: var(--pt-dim);
}
.det-close {
  margin-left: auto;
  background: none;
  border: 0;
  cursor: pointer;
  color: var(--pt-dim);
}
.det-body {
  overflow-y: auto;
  padding: 8px 8px 12px;
}
.det-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--pt-line);
}
.det-item:last-child {
  border-bottom: 0;
}
.det-folio {
  font-weight: 600;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.det-main {
  flex: 1;
  min-width: 0;
}
.det-cli {
  font-weight: 500;
  font-size: 14px;
  color: var(--pt-text);
}
.det-asu {
  font-size: 12px;
  color: var(--pt-dim);
  margin: 1px 0 4px;
}
.det-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 12px;
  font-weight: 600;
}
.det-estatus {
  padding: 2px 8px;
  border-radius: 6px;
}
.det-sla {
  color: var(--pt-muted);
}
.det-av {
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--pt-text);
  white-space: nowrap;
}

@media (min-width: 640px) {
  .areas-grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (min-width: 1024px) {
  .areas-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
